import React, { createContext, useContext } from 'react';
import { TrackedParentNode } from '../models/GTMEventTypes';

type ParentProviderContext = {
    nodeName: string | undefined;
    nodeType: TrackedParentNode;
} & React.PropsWithChildren;

export const ParentNodeContext = createContext<ParentProviderContext>({
    nodeName: undefined,
    nodeType: `Unknown_Parent_Node`,
});

/**
 *
 * @param nodeName The name of the parent node, if any
 * @param nodeType The type of the parent node (e.g. "Navigation", "Single_Column", "Two_Column_Text_Image", etc.)
 * @description This context provider takes a node name and type as its props and provides them to child components so they know who their primary (i.e. "tracked") parent is
 */
export const ParentNodeProvider = ({
    nodeName,
    nodeType,
    children,
}: ParentProviderContext) => {
    return (
        <ParentNodeContext.Provider value={{ nodeName, nodeType }}>
            {children}
        </ParentNodeContext.Provider>
    );
};

export const useParentNodeProvider = () => useContext(ParentNodeContext);
